// @ts-nocheck
import ApplicationState from "@insite/client-framework/Store/ApplicationState";

export const bunzlHeaderSelector = (state: ApplicationState) => {
    return state.bunzl.components.header;
};

export const isFullOpacitySelector = (state: ApplicationState) => {
    return bunzlHeaderSelector(state).isFullOpacity;
};

export const headerHeightSelector = (state: ApplicationState) => {
    return bunzlHeaderSelector(state).headerHeight;
};

export const isHeaderFixedOptionSelector = (state: ApplicationState) => {
    return bunzlHeaderSelector(state).isFixed;
};
